import { Component } from 'react';

import CreditCardForm from 'profile/creditCard/components/CreditCardForm';

import CreditCardPicker from './CreditCardPicker';

class CreditCardLoggedIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCreditCardId: props.selectedCreditCardId
    };
  }

  handleCreditCardChange = (e) => {
    const creditCardId = e.target.value;
    if (creditCardId.length > 0) {
      this.setState({ selectedCreditCardId: creditCardId });
    } else {
      this.setState({ selectedCreditCardId: null });
    }
  };

  render() {
    const { customerCreditCards } = this.props;
    const { selectedCreditCardId } = this.state;
    return (
      <>
        <CreditCardPicker
          customerCreditCards={customerCreditCards.data}
          onCreditCardChange={this.handleCreditCardChange}
        />
        {renderCreditCardForm(selectedCreditCardId)}
      </>
    );
  }
}

const renderCreditCardForm = (selectedCreditCardId) => {
  if (selectedCreditCardId) {
    return null;
  }
  return (
    <>
      <CreditCardForm />
    </>
  );
};

export default CreditCardLoggedIn;
